import { number } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const PropertyItem = iotsUtils.makePartialRecordDecoder(
	constants.wholeHouse.material.property.ids,
	number
);
